import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Box from '@mui/material/Box';
import TAGTypography from '../TAGTypography/TAGTypography';
import TAGSelectContainer from '../TAGButtons/TAGSelectContainer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TAGRadioButtonInput from '../TAGInput/TAGRadioButtonInput';
import { transformedColor } from '../../../constants/themehelper';
export var DayOfWeek;

(function (DayOfWeek) {
  DayOfWeek["Monday"] = "M";
  DayOfWeek["Tuesday"] = "T";
  DayOfWeek["Wednesday"] = "W";
  DayOfWeek["Thursday"] = "T";
  DayOfWeek["Friday"] = "F";
  DayOfWeek["Saturday"] = "S";
})(DayOfWeek || (DayOfWeek = {}));

var TAGPickerFilterTabContent = function TAGPickerFilterTabContent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  var CHECKICONSTYLE = {
    height: '13.33px',
    width: '13.33px',
    position: 'absolute',
    top: '2px',
    right: '2px'
  };
  return React.createElement(Box, {
    maxHeight: '434px',
    sx: _objectSpread({}, props.sx)
  }, React.createElement(TAGTypography, {
    mb: 2,
    gutterBottom: true,
    variant: "bodyLargeBook",
    color: "primary",
    sx: {
      display: 'flex'
    }
  }, "Which days work best?"), Object.entries(DayOfWeek).map(function (_ref2) {
    var _props$weekOfDayButto, _props$weekOfDayButto2;

    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return React.createElement(TAGSelectContainer, {
      key: "".concat(key),
      value: key,
      // selected={props.weekOfDayButton === key}
      selected: (_props$weekOfDayButto = props.weekOfDayButton) === null || _props$weekOfDayButto === void 0 ? void 0 : _props$weekOfDayButto.includes(key),
      onClick: props.onChangesetWeekOfDay,
      sx: {
        margin: '5px',
        width: '45px'
      },
      color: transformedColor(color)
    }, props.weekOfDayButton && props.weekOfDayButton.includes(key) && React.createElement(CheckCircleIcon, {
      sx: CHECKICONSTYLE
    }), React.createElement(TAGTypography, {
      variant: (_props$weekOfDayButto2 = props.weekOfDayButton) !== null && _props$weekOfDayButto2 !== void 0 && _props$weekOfDayButto2.includes(key) ? 'bodyLargeBold' : 'bodyMediumBook',
      color: color
    }, value));
  }), React.createElement(TAGTypography, {
    mb: 2,
    mt: 5,
    variant: "bodyLargeBook",
    color: "primary",
    sx: {
      display: 'flex'
    }
  }, "What time of day?"), React.createElement(TAGRadioButtonInput, {
    value: props.ampmButton || '',
    onChange: props.onChangAmPm,
    color: color,
    radioItems: [{
      inputLabel: 'ALL',
      inputValue: 'ALL',
      fieldDisabled: false
    }, {
      inputLabel: 'AM',
      inputValue: 'AM',
      fieldDisabled: false
    }, {
      inputLabel: 'PM',
      inputValue: 'PM',
      fieldDisabled: false
    }]
  }));
};

export default TAGPickerFilterTabContent;